import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_left_large",
  "use": "icon-arrow_left_large-usage",
  "viewBox": "0 0 52 102",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 52 102\" id=\"icon-arrow_left_large\">\n    <path stroke=\"#029CE6\" d=\"M51 1L1 51l50 50\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol